import { loc } from "../i18n/survey";

const whoMotivatesYouQuestion = {
  name: 'whomotivatesyou',
  title: loc("quiz.whoMotivatesYou.title"),
  type: 'radiogroup',
  choices: [
    {
      value: 'Partner',
      text: loc("quiz.whoMotivatesYou.choices.partner"),
    },
    {
      value: 'Parent',
      text: loc("quiz.whoMotivatesYou.choices.parent"),
    },
    {
      value: 'Sibling',
      text: loc("quiz.whoMotivatesYou.choices.sibling"),
    },
    {
      value: 'Friend',
      text: loc("quiz.whoMotivatesYou.choices.friend"),
    },
    {
      value: 'Teammate',
      text: loc("quiz.whoMotivatesYou.choices.teammate"),
    },
    {
      value: 'Other',
      text: loc("quiz.shared.other"),
    },
  ],
  isRequired: true,
  visibleIf: `{invitationcomfort} == "Yes" || {invitationcomfort} == "It depends"`
};

export default whoMotivatesYouQuestion;